//import logo from "./logo.svg";
import "./App.css";
import "./bslayout.css";
import { Suspense } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Cookies from "js-cookie";
import { version } from "./version";
//import './App.css';

import MainLayout from "./layout/MainLayout";
import Login from "./Login";
import Home from "./Home";
import Reports from "./Reports";
import Invoicing from "./Invoicing";
import Approval from "./Approval";
import Users from "./Users";
import AddUser from "./AddUser";
import Reconciliation from "./Reconciliation";
import ErrorPage from "./error-page";

import AuthenticatedRoute from "./AuthenticatedRoute";



//Add FontAwesome Icons Globally
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlus, faPlusCircle, faCalendar, faThumbsUp, faThumbsDown, faBell, faBars, faReply, faClose } from '@fortawesome/free-solid-svg-icons';
library.add(faPlus, faPlusCircle, faCalendar, faThumbsUp, faThumbsDown, faBell, faBars, faReply, faClose);



function App() {
  console.log("app version", version);
  return (
    <div className="App">
      <HashRouter>
        <Suspense>
          <Routes>
            <Route
              path="/"
              element={<MainLayout />}
              errorElement={<ErrorPage />}
            >
              <Route errorElement={<ErrorPage />}>
                <Route
                  path="/users"
                  element={
                    <AuthenticatedRoute>
                      <Users />
                    </AuthenticatedRoute>
                  }
                ></Route>
                <Route
                  path="/users/new"
                  element={
                    <AuthenticatedRoute>
                      <AddUser />
                    </AuthenticatedRoute>
                  }
                ></Route>
                <Route
                  path="/users/:id"
                  element={
                    <AuthenticatedRoute>
                      <AddUser/>
                    </AuthenticatedRoute>
                  }
                ></Route>
                <Route
                  path="/approval"
                  element={
                    <AuthenticatedRoute>
                      <Approval />
                    </AuthenticatedRoute>
                  }
                ></Route>
                <Route
                  path="/invoicing"
                  element={
                    <AuthenticatedRoute>
                      <Invoicing />
                    </AuthenticatedRoute>
                  }
                ></Route>
                <Route
                  path="/reconciliation"
                  element={
                    <AuthenticatedRoute>
                      <Reconciliation />
                    </AuthenticatedRoute>
                  }
                ></Route>
                <Route
                  path="/reports"
                  element={
                    <AuthenticatedRoute>
                      <Reports />
                    </AuthenticatedRoute>
                  }
                ></Route>
              </Route>
            </Route>

            <Route exact path="/login" element={<Login />} />
            <Route
              exact
              path="/home"
              element={
                <AuthenticatedRoute>
                  <Home />
                </AuthenticatedRoute>
              }
            />
          </Routes>
        </Suspense>
      </HashRouter>

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

//Set Default Headers for all requests
// Add a request interceptor
axios.interceptors.request.use(function (config) {
  if (Cookies.get("access_token")) {
    const access_token = Cookies.get("access_token");
    //config.headers = headers;
    config.headers.Authorization = `Bearer ${access_token}`;
  }

  return config;
});

export default App;
